import { Icon } from '@iconify/react'

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  onClick,
  disabled = false,
  type = 'button',
  className = '',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center gap-2 font-semibold rounded-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed'
  
  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    danger: 'bg-danger text-white hover:bg-red-600 shadow-md hover:shadow-lg',
    warning: 'bg-yellow-500 text-white hover:bg-yellow-600 shadow-md hover:shadow-lg',
    icon: 'bg-transparent text-text-secondary hover:bg-bg-light hover:text-indigo-600 p-2 rounded-lg',
  }

  const sizes = {
    sm: 'px-3 py-1.5 md:px-4 md:py-2 text-xs md:text-sm',
    md: 'px-4 py-2 md:px-6 md:py-3 text-sm md:text-base',
    lg: 'px-6 py-3 md:px-8 md:py-4 text-base md:text-lg',
  }

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
      {...props}
    >
      {icon && iconPosition === 'left' && <Icon icon={icon} className="text-lg" />}
      {children}
      {icon && iconPosition === 'right' && <Icon icon={icon} className="text-lg" />}
    </button>
  )
}

export default Button
